module.exports = __webpack_public_path__ + "static/media/frutti_bosco.67e43852.svg";